import { useEffect } from 'react';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
export const useTransitionAwareFocus = (inputRef, shouldFocus) => {
  useEffect(() => {
    if (!shouldFocus) {
      return () => {};
    }

    const input = inputRef.current;

    const focusInput = () => {
      if (input) {
        input.focus();
        input.removeEventListener('transitionend', focusInput);
      }
    };

    if (isTransitionAndAnimationsDisabled()) {
      // If transitions are disabled we can just focus right away...
      if (input) {
        input.focus();
      }
    } else {
      if (input) {
        // If transitioning, wait for the transitionend event.
        input.addEventListener('transitionend', focusInput);
      }
    }

    return () => {
      // Clean up
      if (!isTransitionAndAnimationsDisabled() && input) {
        input.removeEventListener('transitionend', focusInput);
      }
    };
  }, [inputRef, shouldFocus]);
};